<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 px-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top">
        <div class="col">
          <div>
            <h4>
              <svg
                width="24"
                height="24"
                fill="currentColor"
                class="bi-file-earmark me-2 b-icon bi"
                viewBox="0 0 16 16"
                version="1.1"
                id="svg4"
              >
                <path
                  d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                  id="path2"
                />
                <path
                  d="m 5.1218042,10.781435 h 0.7648806 c 0.2424881,2.088851 1.6218635,3.295535 3.7970601,3.295535 0.4475591,0 0.8397131,-0.04893 1.1937321,-0.133116 V 13.00844 c -0.348262,0.08563 -0.75193,0.122323 -1.1937321,0.122323 -1.5110531,0 -2.4860418,-0.862019 -2.7162975,-2.348608 H 9.8578749 V 10.114413 H 6.9185181 V 9.4409161 c 0,-0.07915 0,-0.1575811 0.00576,-0.2367316 H 9.8585939 V 8.5371627 H 7.0055835 C 7.2847685,7.1714586 8.242488,6.3893088 9.6844639,6.3893088 c 0.4418031,0 0.8454701,0.035977 1.1937321,0.1273602 V 5.5819749 A 4.7612557,4.7612557 0 0 0 9.6844639,5.4423824 c -2.1068389,0 -3.4682256,1.1289724 -3.7733144,3.0940606 H 5.1218042 V 9.2041845 H 5.8485487 V 10.114413 H 5.1218042 v 0.667742 z"
                  id="path2-4"
                />
              </svg>
              Abrechnung - Alle Belege
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <!-- SEARCH FIELD  -->
            <b-input-group class="ml-2 header-search-field">
              <b-form-input
                type="search"
                size="sm"
                v-model.lazy="searchText"
                :class="{ 'bg-primary-light-3': searchText !== '' }"
              ></b-form-input>
              <template #prepend>
                <b-input-group-text>
                  <b-icon variant="dark" icon="search" />
                </b-input-group-text>
              </template>
            </b-input-group>
            <!-- FILTER BUTTON  :disabled="!isDeleteButtonEnabled"-->
            <b-button
              size="sm"
              :variant="filterToggle == true ? 'primary' : 'light'"
              class="ml-2"
              :pressed="filterToggle"
              @click="filterRecords"
              :disabled="selectedRows.length == 0 && !filterToggle"
            >
              <b-icon icon="funnel"></b-icon>
            </b-button>
            <!-- HELP ICON  -->
            <b-button size="sm" variant="light" class="ml-2" href="https://www.bauvisor.de/abrechnung/" target="_blank">
              <b-icon icon="question-circle" variant="dark" class=""></b-icon>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="main-canvas">
      <div class="shadow-muted-super" ref="budgetSummarySection">
        <table class="w-100 bg-white">
          <tr class="border">
            <td class="px-2 py-1" colspan="8" v-b-toggle.collapse-invoices @click="onWindowResize()">
              <small>Übersicht - Aktuelle Abrechnung</small>
            </td>
            <td class="text-right pr-2">
              <b-button v-b-toggle.collapse-invoices variant="white" size="sm" @click="onWindowResize()">
                <span class="when-opened">
                  <b-icon icon="chevron-up" class="action-button" />
                </span>
                <span class="when-closed"><b-icon icon="chevron-down" class="action-button" /></span>
              </b-button>
            </td>
          </tr>
        </table>

        <b-collapse id="collapse-invoices" :visible="isTabOpen">
          <b-overlay :show="isHeaderLoading" rounded="sm" spinner-variant="primary" opacity="0.8">
            <table class="w-100 bg-white">
              <tr class="border border-top-0 border-bottom-0">
                <td class="p-2 font-weight-bold small border-bottom">VE-Budget</td>
                <td class="font-weight-bold border-bottom text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetVEBudget, SettingsStore) }}
                  </div>
                </td>
                <td class="border-bottom">&nbsp;</td>
              </tr>
              <tr>
                <td class="p-2 pl-4 font-weight-bold border-left small">Entfallende Leistungen</td>
                <td class="font-weight-bold border-bottom text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetVESkipped, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right border-bottom text-right pr-2 small">
                  <small>{{ $utils.numberWithMaxFrictionsDE((budgetVESkipped / budgetVEBudget) * 100, 1) }}%</small>
                </td>
                <td colspan="6" class="border-right">&nbsp;</td>
              </tr>
              <tr>
                <td class="p-2 pl-4 font-weight-bold border-left border-top border-bottom small">Offenes Budget</td>
                <td class="font-weight-bold border-bottom text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{
                      $utils.formatCurrency(
                        this.budgetVEBudgetOpen + this.budgetVEBudgetAusgeschrieben + this.budgetVEBudgetAusgewertet,
                        SettingsStore
                      )
                    }}
                  </div>
                </td>
                <td class="border-right border-bottom text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        ((this.budgetVEBudgetOpen +
                          this.budgetVEBudgetAusgeschrieben +
                          this.budgetVEBudgetAusgewertet) /
                          budgetVEBudget) *
                          100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td colspan="6" class="border-bottom border-right">&nbsp;</td>
              </tr>

              <tr>
                <td class="p-0 pt-2 pb-1 pl-4 font-weight-bold border-left small">Beauftragtes Budget</td>
                <td class="font-weight-bold text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{
                      $utils.formatCurrency(this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced, SettingsStore)
                    }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        ((this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced) / budgetVEBudget) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td class="p-0 pt-2 pb-1 pl-4 font-weight-bold small">Gesamtaufträge</td>
                <td class="font-weight-bold text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountSaldo, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (this.budgetOrderAmountSaldo / (this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced)) *
                          100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td class="p-0 pt-2 pb-1 pl-4 font-weight-bold small">Leistung abgerechnet</td>
                <td class="font-weight-bold text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountLeistungInvoiced, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (this.budgetOrderAmountLeistungInvoiced / this.budgetOrderAmountSaldo) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>

              <tr>
                <td class="p-0 pl-5 border-left small">in Arbeit befindlich</td>
                <td class="p-0 text-right small">
                  <div class="m-0 px-2">
                    {{ $utils.formatCurrency(this.budgetVEBudgetInArbeit, SettingsStore) }}
                  </div>
                </td>
                <td class="p-0 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (budgetVEBudgetInArbeit / (this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced)) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td class="p-0 pl-5 small">in Arbeit befindlich</td>
                <td class="p-0 text-right small">
                  <div class="m-0 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountInArbeit, SettingsStore) }}
                  </div>
                </td>
                <td class="p-0 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE((budgetOrderAmountInArbeit / budgetOrderAmountSaldo) * 100, 1)
                    }}%
                  </small>
                </td>
                <td class="p-0 pl-5 small">teilabgerechnet</td>
                <td class="p-0 text-right small">
                  <div class="m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountLeistungInvoicedPartly, SettingsStore) }}
                  </div>
                </td>
                <td class="p-0 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (budgetOrderAmountLeistungInvoicedPartly / budgetOrderAmountInArbeit) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>
              <tr>
                <td class="p-0 pl-5 border-left small">&nbsp;</td>
                <td class="p-0 small">&nbsp;</td>
                <td class="p-0 border-right text-right small">&nbsp;</td>
                <td class="p-0 small"></td>
                <td class="p-0 small"></td>
                <td class="p-0 border-right text-right pr-2 small">&nbsp;</td>
                <td class="p-0 pl-5 small">Obligo</td>
                <td class="p-0 text-right small">
                  <div class="m-0 py-1 px-2">
                    {{
                      $utils.formatCurrency(
                        this.budgetOrderAmountInArbeit - this.budgetOrderAmountLeistungInvoicedPartly,
                        SettingsStore
                      )
                    }}
                  </div>
                </td>
                <td class="p-0 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        ((budgetOrderAmountInArbeit - budgetOrderAmountLeistungInvoicedPartly) /
                          budgetOrderAmountInArbeit) *
                          100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>
              <tr>
                <td class="p-0 pl-5 border-left small">schlussgerechnet</td>
                <td class="text-right small">
                  <div class="m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetVEBudgetInvoiced, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (budgetVEBudgetInvoiced / (this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced)) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td class="p-0 pl-5 small">schlussgerechnet</td>
                <td class="text-right small">
                  <div class="m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountInvoiced, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE((budgetOrderAmountInvoiced / budgetOrderAmountSaldo) * 100, 1)
                    }}%
                  </small>
                </td>
                <td class="p-0 pl-5 small">schlussgerechnet</td>
                <td class="text-right small">
                  <div class="m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountLeistungInvoicedFinal, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (budgetOrderAmountLeistungInvoicedFinal / budgetVEBudgetInvoiced) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>
              <tr>
                <td class="p-0 pl-5 pb-2 border-left small">&nbsp;</td>
                <td class="p-0 pb-2 small">&nbsp;</td>
                <td class="p-0 pb-2 border-right text-right small">&nbsp;</td>
                <td class="p-0 pb-2 small"></td>
                <td class="p-0 pb-2 small"></td>
                <td class="p-0 pb-2 border-right text-right pr-2 small">&nbsp;</td>
                <td class="p-0 pb-2 pl-5 small">Budgetunterschreitung</td>
                <td class="p-0 pb-2 text-right small">
                  <div class="m-0 py-1 px-2">
                    {{
                      $utils.formatCurrency(
                        this.budgetVEBudgetInvoiced - this.budgetOrderAmountLeistungInvoicedFinal,
                        SettingsStore
                      )
                    }}
                  </div>
                </td>
                <td class="p-0 pb-2 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        ((budgetVEBudgetInvoiced - budgetOrderAmountLeistungInvoicedFinal) / budgetVEBudgetInvoiced) *
                          100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>
            </table>
          </b-overlay>
        </b-collapse>
      </div>

      <b-nav
        tabs
        class="mt-3 pl-2"
        v-if="!$route.path.endsWith('/create')"
        style="margin-left: -25px; margin-right: -25px"
      >
        <b-nav-item
          to="/invoices"
          v-if="$route.name !== 'Chancen & Risiken Details' && $route.name !== 'Chancen & Risiken Formular'"
          exact
          style="padding-left: 16px"
        >
          Vergabeeinheiten
        </b-nav-item>
        <b-nav-item
          to="/invoices/all"
          v-if="$route.name !== 'Chancen & Risiken Details' && $route.name !== 'Chancen & Risiken Formular'"
        >
          Belege
        </b-nav-item>
      </b-nav>
      <div class="table-wrapper shadow-muted-super mt-3">
        <b-overlay :show="isTableLoading" rounded="sm" spinner-variant="primary" opacity="0.6" z-index="1100">
          <b-table
            v-resizable-columns="{ fields: visibleFields, storageKey: 'invoiceall', flexLast: false, minWidth: 0 }"
            :items="records"
            :fields="visibleFields"
            @row-selected="onRowSelected"
            ref="theTable"
            selectable
            class="bg-white sum-header mb-0"
            hover
            head-variant="light"
            show-empty
            small
            @row-clicked="item => $router.push('/invoices/' + item.OrderId + '/' + item.DbId)"
            tbody-tr-class="action-button"
            no-border-collapse
            :sticky-header="tableHeight"
            :filter="searchText"
            @filtered="filteredItems => (displayedItemsCount = filteredItems.length)"
          >
            <template #head(checked)>
              <b-form-checkbox
                class="ml-2"
                :disabled="records.length == 0"
                v-model="checkedAllTableEntries"
                @change="onCheckAllTableEntries"
              ></b-form-checkbox>
            </template>
            <template #head(actions)="data">
              {{ data.label }}
              <!--
              <span>
                <b-icon
                  icon="three-dots-vertical"
                  v-b-modal.column-selector-invoices-modal
                  class="float-right no-outline"
                  style="margin-top: 4px"
                />
              </span>-->
              <span @click="$bvModal.show('invoiceAll')" role="button">
                <b-icon icon="three-dots-vertical" class="float-right no-outline" style="margin-top: 4px" />
              </span>
              <!--
              <b-modal
                cancel-disabled
                ok-disabled
                hide-footer
                hide-backdrop
                hide-header
                no-fade
                id="column-selector-invoices-modal"
                body-class="p-0"
                content-class="border-0"
              >
                <b-list-group>
                  <b-list-group-item v-for="item in fields.filter(x => x.hideable == true)" :key="item.key" class="p-2">
                    <b-form-checkbox
                      @change="onClickColumnVisible(item)"
                      v-model="item.visible"
                      value="true"
                      unchecked-value="false"
                    >
                      {{ item.label }}
                    </b-form-checkbox>
                  </b-list-group-item>
                </b-list-group>
              </b-modal> -->
            </template>
            <template #cell(checked)="data">
              <b-form-checkbox
                class="ml-2"
                @change="checked(data)"
                v-model="data.rowSelected"
                :disabled="data.item.editMode"
              ></b-form-checkbox>
            </template>

            <template #cell(AmountCheckedType)="data">
              <b-icon :icon="data.item.AmountCheckedType == 'K' ? 'chevron-contract' : 'chevron-up'" />
            </template>
            <template #cell(actions)="data">
              <div style="width: 110px">
                <b-icon
                  class="action-button text-grey"
                  style="width: 18px; height: 18px"
                  icon="arrow-right"
                  title="Beleg öffnen"
                  @click.stop="$router.push('/invoices/' + data.item.OrderId + '/' + data.item.DbId)"
                />
                <b-icon
                  class="action-button text-grey ml-2"
                  style="width: 18px; height: 18px"
                  icon="bookmarks"
                  title="Rechnungsbegleitblatt öffnen"
                  @click.stop="openInvoiceSheet(data.item)"
                />
                <!--
                <b-icon
                  icon="trash"
                  variant="grey"
                  class="action-button ml-2"
                  style="width: 16px; height: 16px"
                  title="Beleg löschen"
                  v-show="records.find(x => x.Index > data.item.Index) == null"
                  @click.stop="deleteRecord(data.item)"
                /> -->
                <!-- totes icon, um dem user ein deaktiviertes icon darzustellen -->
                <!--
                <b-icon
                  icon="trash"
                  variant="grey"
                  class="ml-2"
                  style="width: 16px; height: 16px; cursor: not-allowed; color: #ddd"
                  title="Nur der letzte Beleg darf gelöscht werden."
                  v-show="records.find(x => x.Index > data.item.Index) != null"
                  @click.stop="records.find(x => x.Index > data.item.Index)"
                />-->
              </div>
            </template>
            <template #cell(Status)="data">
              <b-badge
                pill
                class="sr-kennzeichen py-0 px-1"
                v-if="data.item.Status == 2"
                variant="primary"
                style="font-size: 100%"
              >
                <b-icon class="p-0" icon="check-2" variant="white" />
              </b-badge>
            </template>
          </b-table>
        </b-overlay>
      </div>
      <TableFooter
        :displayed-count="displayedItemsCount"
        :selected-count="selectedRows.length"
        :loading="isTableLoading"
      />
    </div>

    <TableColumnSelector
      :fields="fields"
      id="invoiceAll"
      storage-key="invoiceall"
      @ok="AppState.updateVisibleFields('invoiceAll', fields)"
    ></TableColumnSelector>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import SettingsStore from '@/store/Settings';
import BudgetService from '@/service/BudgetService';
import InvoicesService from '../service/InvoicesService';
import TableColumnSelector from '@/components/TableColumnSelector';
import TableFooter from '@/components/TableFooter';

export default {
  components: {
    TableColumnSelector,
    TableFooter
  },
  data() {
    return {
      SettingsStore,
      AppState,
      records: [],
      filterToggle: false,
      selectedRows: [],
      isHeaderLoading: true,
      isTableLoading: true,
      tableHeight: '420px',
      displayedItemsCount: 0,
      checkedAllTableEntries: false,
      searchText: '',
      budgetKKE: 0.0,
      budgetPAT: 0.0,
      budgetVEBudget: 0.0,
      budgetVESkipped: 0.0,
      budgetVEBudgetOpen: 0.0,
      budgetVEBudgetInvoiced: 0.0,
      budgetVEBudgetAusgeschrieben: 0.0,
      budgetVEBudgetAusgewertet: 0.0,
      budgetVEBudgetInArbeit: 0.0,
      budgetOrderAmountSaldo: 0.0,
      budgetOrderAmountInvoiced: 0.0,
      budgetOrderAmountInArbeit: 0.0,
      budgetOrderAmountLeistungInvoiced: 0.0,
      budgetOrderAmountLeistungInvoicedFinal: 0.0,
      budgetOrderAmountLeistungInvoicedPartly: 0.0,
      fields: [
        {
          hideable: false,
          visible: true,
          key: 'checked',
          label: '',
          tdClass: 'sticky-col first-col text-center align-middle',
          thClass: 'sticky-col first-col text-center align-top noselect',
          thStyle: 'z-index: 1002;width: 40px;',
          tdStyle: 'z-index: 9;'
        },
        {
          hideable: false,
          visible: true,
          key: 'Index',
          label: 'ZF-Nr.',
          thClass: 'align-top sticky-col second-col',
          tdClass: ' sticky-col second-col',
          thStyle: 'z-index: 1002;width: 140px;',
          tdStyle: 'z-index: 9;',
          sortable: true
        },
        // hier neue felder 2-10
        {
          hideable: false,
          visible: true,
          key: 'SupplierText',
          label: 'Auftragnehmer',
          thClass: 'align-top sticky-col third-col',
          tdClass: ' sticky-col third-col',
          thStyle: 'z-index: 1002;width: 300px;',
          tdStyle: 'z-index: 9;',
          sortable: true
        },
        {
          hideable: false,
          visible: true,
          key: 'OrderStatus',
          label: 'Auftragsstatus / Datum',
          thClass: 'align-top ',
          sortable: true,
          formatter: (value, key, item) => {
            if (item.veSection && item.veSection == 'A') {
              return (
                (item.VergabeEmpfehlung && item.VergabeEmpfehlung != '' ? item.VergabeEmpfehlung : 'Empfehlung') +
                ' / ' +
                this.$utils.SQLDateToGermanDate(item.VergabeEmpfehlungDatum)
              );
            } else if (item.veSection && item.veSection == 'B') {
              return (
                (item.OrderNumber && item.OrderNumber != '' ? item.OrderNumber : 'Bestellung') +
                ' / ' +
                this.$utils.SQLDateToGermanDate(item.OrderDate)
              );
            } else return '';
          },
          sortByFormatted: true
        },
        {
          hideable: false,
          visible: true,
          key: 'Ordinal',
          label: 'VE',
          thClass: 'align-top ',
          sortable: true
        },
        {
          hideable: false,
          visible: true,
          key: 'DisplayName',
          label: 'Bezeichnung',
          thClass: 'align-top ',
          sortable: true
        },
        {
          hideable: false,
          visible: true,
          key: 'KGR',
          label: 'Kostengruppe',
          thClass: 'align-top ',
          sortable: true
        },
        {
          hideable: false,
          visible: true,
          key: 'Responsible',
          label: 'Verantwortlich',
          thClass: 'align-top ',
          sortable: true
        },
        {
          hideable: true,
          visible: true,
          key: 'FA1',
          label: SettingsStore.settings['FA1'],
          sortable: true,
          thClass: 'align-top'
        },
        {
          hideable: true,
          visible: true,
          key: 'FA2',
          label: SettingsStore.settings['FA2'],
          sortable: true,
          thClass: 'align-top'
        },
        {
          hideable: false,
          visible: true,
          key: 'ProcessStatus',
          label: 'Status',
          thClass: 'align-top ',
          sortable: true
        },
        {
          visible: true,
          hideable: false,
          key: 'RDate',
          label: 'Rg.Datum',
          thClass: 'align-top ',
          sortable: true,
          formatter: x => (x = this.$utils.SQLDateToGermanDate(x))
        },

        {
          hideable: false,
          visible: true,
          key: 'Type',
          label: 'Art',
          thClass: 'align-top ',
          tdClass: '',
          sortable: true,
          formatter: x => (x = this.AppState.invoiceTypes.find(y => y.DbId == x).Abbreviation)
        },
        {
          visible: true,
          hideable: false,
          key: 'AmountCheckedType',
          label: '',
          thClass: 'align-top ',
          sortable: true
        },

        {
          visible: true,
          hideable: true,
          key: 'Amount',
          label: 'Rg. ungeprüft netto',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:120px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'CreatedDate',
          label: 'Erfassungs-datum',
          thClass: 'align-top',
          thStyle: 'min-width:100px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => this.$utils.SQLDateToGermanDate(x)
        },
        {
          visible: true,
          hideable: true,
          key: 'AmountChecked',
          label: 'Rg. geprüft netto',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'Status',
          label: '',
          thClass: 'align-top ',
          sortable: true
        },
        {
          visible: true,
          hideable: true,
          key: 'CheckedDate',
          label: 'Geprüft am',
          thClass: 'align-top',
          thStyle: 'min-width:100px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => this.$utils.SQLDateToGermanDate(x)
        },
        {
          visible: true,
          hideable: true,
          key: 'LZWAmountChecked',
          label: 'Leistungs-zuwachs',
          thClass: 'align-top text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'LZWAccumulatedChecked',
          label: 'Leistungs-stand',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMAmount',
          label: 'EGMin mVK geprüft',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMZWAmount',
          label: 'EGMin mVK Zuwachs',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMAcc',
          label: 'EGMin mVK kumuliert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SEBAmount',
          label: 'SEB VE geprüft',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SEBZWAmount',
          label: 'SEB VE Zuwachs',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SEBAcc',
          label: 'SEB VE kumuliert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'GAAmount',
          label: 'Gesamtanspruch netto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'UStChecked',
          label: 'USt.-\nSatz',
          thClass: 'align-top text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          tdClass: 'text-right',
          sortable: true
        },
        {
          visible: true,
          hideable: true,
          key: 'GAUStAmount',
          label: 'GA USt.-Wert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'GABrutto',
          label: 'Gesamtanspruch brutto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZAAmount',
          label: 'Zahl.anspruch netto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },

        {
          visible: true,
          hideable: true,
          key: 'ZAUStAmount',
          label: 'ZA USt.-Wert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZABrutto',
          label: '(Zahl.anspruch\nbrutto o UStA.)',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:130px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'UStAusgleich',
          label: 'USt-\nAusgleich',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZAUStAmountSum',
          label: '(SummeAlt\nZA_UStWert)',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZAUStAmountIncl',
          label: '(ZA_UStWert\nInklAusgleich)',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },

        {
          visible: true,
          hideable: true,
          key: 'ZABruttoIncl',
          label: '(Zahl.Anspruch\nbrutto m USt.A.)',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:140px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZABruttoMaßgeblich',
          label: 'Zahl.Anspruch\nbrutto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMOAmount',
          label: 'EGMin oVK Zuwachs',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMOAmountAccumulated',
          label: 'EGMin oVK kumuliert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        /*
        {
          visible: true,
          hideable: true,
          key: 'MSicherVon',
          label: 'Netto/Brutto Auftragssumme',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true
        },*/
        {
          visible: true,
          hideable: true,
          key: 'SFMPercent',
          label: 'SEB MH\nSatz',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:80px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.numberWithMaxFrictionsDE(x, 1))
        },
        {
          visible: true,
          hideable: true,
          key: 'SFMBasisAmount',
          label: 'SEB MH Basiswert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },

        {
          visible: true,
          hideable: true,
          key: 'SFMMHAmount',
          label: 'SEB MH',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SFMMHDeltaAmount',
          label: 'SEB MH Veränderung',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'AZAmount',
          label: 'Auszahlung brutto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SkontoProzent',
          label: 'Skonto-\nSatz',
          thClass: 'align-top text-right',
          thStyle: 'min-width:80px;white-space: pre-line;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.numberWithMaxFrictionsDE(x, 1))
        },
        {
          visible: true,
          hideable: true,
          key: 'SkontoAmount',
          label: 'Skonto-\nBetrag',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'AZNachSkonto',
          label: 'Zahlbetrag nach Skonto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          hideable: false,
          visible: true,
          key: 'actions',
          label: 'Aktionen',
          tdClass: 'sticky-col last-col text-center align-middle',
          thClass: 'sticky-col last-col align-top noselect',
          thStyle: 'z-index: 1002;'
        }
      ]
    };
  },
  created() {
    this.$eventBus.$on('projectSwitched', () => {
      this.searchText = '';
    });
  },
  activated() {
    this.isLoading = true;
    this.isHeaderLoading = true;
    AppState.isLoading = false;
    AppState.loadVisibleFields('invoiceAll', this.fields);
    window.addEventListener('resize', this.onWindowResize); // listen for windows size changes, to re-compute height of controls

    this.fields.find(x => x.key == 'KGR').hideable = SettingsStore.settings['KGR_Selections_Active'] == 'true';
    this.fields.find(x => x.key == 'Responsible').hideable =
      SettingsStore.settings['Responsible_Selections_Active'] == 'true';
    this.fields.find(x => x.key == 'FA1').hideable = SettingsStore.settings['FA1_Active'] == 'true';
    this.fields.find(x => x.key == 'FA2').hideable = SettingsStore.settings['FA2_Active'] == 'true';

    this.fields.find(x => x.key == 'KGR').visible =
      this.fields.find(x => x.key == 'KGR').visible && SettingsStore.settings['KGR_Selections_Active'] == 'true';
    this.fields.find(x => x.key == 'Responsible').visible =
      this.fields.find(x => x.key == 'Responsible').visible &&
      SettingsStore.settings['Responsible_Selections_Active'] == 'true';
    this.fields.find(x => x.key == 'FA1').visible =
      this.fields.find(x => x.key == 'FA1').visible && SettingsStore.settings['FA1_Active'] == 'true';
    this.fields.find(x => x.key == 'FA2').visible =
      this.fields.find(x => x.key == 'FA2').visible && SettingsStore.settings['FA2_Active'] == 'true';

    this.fields.find(x => x.key == 'FA1').label = SettingsStore.settings['FA1'];
    this.fields.find(x => x.key == 'FA2').label = SettingsStore.settings['FA2'];

    BudgetService.getSummary()
      .then(summary => {
        this.budgetKKE = summary.KkeBudgetSummary;
        this.budgetPAT = summary.PatBudgetSummary;

        this.budgetVESkipped = summary.VEBudgetSkipped;
        this.budgetVEBudgetOpen = summary.VEBudgetOpen;
        this.budgetVEBudgetInvoiced = summary.VEBudgetInvoiced;
        this.budgetVEBudgetAusgeschrieben = summary.VEBudgetAusgeschrieben;
        this.budgetVEBudgetAusgewertet = summary.VEBudgetAusgewertet;
        this.budgetVEBudgetInArbeit = summary.VEBudgetInArbeit;
        this.budgetOrderAmountSaldo = summary.OrderAmountSaldo;
        this.budgetOrderAmountInvoiced = summary.OrderAmountInvoiced;
        this.budgetOrderAmountInArbeit = summary.OrderAmountInArbeit;
        this.budgetOrderAmountLeistungInvoiced = summary.OrderAmountLeistungInvoiced;
        this.budgetOrderAmountLeistungInvoicedFinal = summary.OrderAmountLeistungInvoicedFinal;
        this.budgetOrderAmountLeistungInvoicedPartly = summary.OrderAmountLeistungInvoicedPartly;
        // ----------
        this.budgetVEBudget =
          this.budgetVESkipped +
          this.budgetVEBudgetOpen +
          this.budgetVEBudgetAusgeschrieben +
          this.budgetVEBudgetAusgewertet +
          this.budgetVEBudgetInArbeit +
          this.budgetVEBudgetInvoiced;
      })
      .catch(err => console.log(err.toString()))
      .finally(() => {
        this.isHeaderLoading = false;
      });
    this.isTableLoading = true;
    InvoicesService.get()
      .then(invoices => {
        this.isTableLoading = false;
        this.records = invoices;
        this.displayedItemsCount = this.records.length;

        this.selectedRows.forEach(row => {
          this.$nextTick(() => this.$refs.theTable.selectRow(this.records.findIndex(item => row.DbId == item.DbId)));
        });

        if (this.filterToggle) {
          this.recordsBackup = [...this.records];
          this.records = this.selectedRows;
          this.displayedItemsCount = this.records.length;
          this.$nextTick(() => {
            this.$refs.theTable.selectAllRows();
          });
        }
      })
      .finally(() => {
        this.onWindowResize();
        if (AppState.scrollPosition[this.$route.path])
          this.$refs.theTable.$el.scrollTo({
            top: AppState.scrollPosition[this.$route.path][0],
            left: AppState.scrollPosition[this.$route.path][1]
          });
      });
  },
  deactivated() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  computed: {
    isTabOpen() {
      return localStorage.getItem('collapse-invoices') == 'true' ? true : false;
    },
    visibleFields() {
      return this.fields.filter(field => field.visible == true || field.visible == 'true');
    }
  },
  methods: {
    openInvoiceSheet(item) {
      const routeData = this.$router.resolve({
        name: 'Rechnungsbegleitblatt',
        params: { id: item.OrderId, iid: item.DbId },
        query: { nav: 'false' }
      });
      window.open(routeData.href, '_blank');
    },
    onCheckAllTableEntries() {
      if (this.checkedAllTableEntries) {
        this.$refs.theTable.selectAllRows();
      } else {
        this.$refs.theTable.clearSelected();
      }
    },
    onRowSelected(selectedItems) {
      this.selectedRows = selectedItems;
      if (selectedItems.length < this.records.length) {
        this.checkedAllTableEntries = false;
      } else {
        this.checkedAllTableEntries = true;
      }
    },
    onWindowResize() {
      setTimeout(() => {
        const totalHeight = window.innerHeight;
        const budgetSummarySection = this.$refs.budgetSummarySection;
        const tableHeight = totalHeight - budgetSummarySection.offsetHeight - 200;
        this.tableHeight = tableHeight + 'px';
      }, 300);
    },
    onClickColumnVisible() {
      AppState.updateVisibleFields('invoiceAll', this.fields);
    },
    filterRecords() {
      if (!this.filterToggle) {
        this.filterToggle = true;
        this.recordsBackup = [...this.records];
        this.records = this.selectedRows;
        this.displayedItemsCount = this.records.length;
        this.$nextTick(() => {
          this.$refs.theTable.selectAllRows();
        });
      } else {
        this.filterToggle = false;
        this.records = this.recordsBackup;
        this.displayedItemsCount = this.records.length;

        this.selectedRows.forEach(row => {
          this.$nextTick(() => this.$refs.theTable.selectRow(this.records.findIndex(item => row.DbId == item.DbId)));
        });
      }
      //this.recalcSums(this.records);
    },
    checked(data) {
      if (data.rowSelected) {
        this.$refs.theTable.selectRow(data.index);
      } else {
        this.$refs.theTable.unselectRow(data.index);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    AppState.scrollPosition[from.path] = [this.$refs.theTable.$el.scrollTop, this.$refs.theTable.$el.scrollLeft];
    next();
  }
};
</script>

<style>
.table-wrapper {
  overflow: auto;
  white-space: nowrap;
  border: 1px solid #dee2e6;
}

.table-wrapper .first-col {
  left: 0;
}

.table-wrapper .second-col {
  left: 40px;
}

.table-wrapper .third-col {
  left: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.table-wrapper .last-col {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
  right: 0;
}

.table-wrapper tbody tr:last-child td {
  border-bottom: 1px solid var(--bauvisor-border);
}

.table-wrapper tbody tr td.sticky-col {
  background-color: var(--bauvisor-primary-light) !important;
}

.table-wrapper tbody tr:hover td {
  background-color: #ebebeb !important;
}

.table-wrapper .table-striped tbody tr:nth-of-type(odd) td.sticky-col {
  background-color: #efefef !important;
}

.table-wrapper .table-striped tbody tr:nth-of-type(even) td.sticky-col {
  background-color: #f5f5f5 !important;
}

.table-wrapper td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}

.table-wrapper td:last-child {
  border-left: 1px solid #ced2d6;
}

.table-wrapper td:nth-last-child(2) {
  border-left: none;
  border-right: none;
}

.table-wrapper .table.b-table > tbody > .table-active,
.table-wrapper .table.b-table > tbody > .table-active > th,
.table-wrapper .table.b-table > tbody > .table-active > td {
  background-color: #f5f5f5;
}

#column-selector-invoices-modal > .modal-dialog {
  position: absolute;
  top: 500px;
  right: 13px;
}

.sr-kennzeichen {
  display: inline;
  vertical-align: middle;
  border-radius: 4px;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
